import * as yup from "yup";

export const signupFormSchema = yup.object({
  first_name: yup
    .string()
    .matches(/^[a-zA-Z]+$/, "First name is invalid")
    .required("First name is required"),

  last_name: yup
    .string()
    .matches(/^[a-zA-Z]+$/, "Last name is invalid")
    .required("Last name is required"),

  email: yup
    .string()
    .email("Invalid email address")
    .matches(
      /\.(com|in|org|net|gov|uk|de|fr|jp|cn|edu)$/,
      "Email must end with a valid extension"
    )
    .required("Email is required"),

  phone: yup
    .string()
    .matches(/^[0-9]{10,15}$/, "Phone number must be 10–15 digits")
    .required("Phone number is required"),

  password: yup.string().required("Password is required"),

  agreeToTerms: yup
    .boolean()
    .oneOf([true], "You must accept the terms and privacy policy"),
});

export const contactUpdateSchema = yup.object({
  new_email: yup
    .string()
    .email("Invalid email address")
    .matches(
      /\.(com|in|org|net|gov|uk|de|fr|jp|cn|edu)$/,
      "Email must end with a valid extension"
    ),
  new_phone: yup
    .string()
    .matches(/^[0-9]{10,15}$/, "Phone number must be 10–15 digits"),
});

// export const magicLinkSchema = yup.object({
//   email: yup.string()
//     .email("Invalid email address")
//     .required("Email is required"),
// });

// export const mobileLinkSchema = yup.object({
//   mobile: yup.string()
//     .matches(/^[0-9]{10}$/, "Mobile number must contain exactly 10 digits")
//     .required("Mobile number is required"),
// });